import axios from 'axios'
import { authHeader } from './auth'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

/**
 * ISO3 pour &pays= — aligné sur la liste auth : { code, libelle, translated_name } (voir API annonceur).
 */
function paysIso3ForQuartierUrl (pays, countries) {
  if (pays == null || pays === '') {
    return null
  }
  const raw = String(pays).trim()
  if (!raw) {
    return null
  }
  const upper = raw.toUpperCase()
  const lower = raw.toLowerCase()
  const list = countries || []
  for (let i = 0; i < list.length; i++) {
    const c = list[i]
    const v = c && (c.code || c.alpha3 || c.cca3 || c.code_iso_3166_alpha3 || c.codeIso3166Alpha3)
    if (!v) {
      continue
    }
    const iso3 = String(v).trim().toUpperCase()
    if (upper === iso3) {
      return iso3
    }
    if (c.libelle === raw || c.translated_name === raw) {
      return iso3
    }
    if ((c.libelle && c.libelle.toLowerCase() === lower) || (c.translated_name && c.translated_name.toLowerCase() === lower)) {
      return iso3
    }
  }
  if (/^[A-Za-z]{3}$/.test(raw)) {
    return upper
  }
  return null
}

export function upperCase (string) {
  return string.charAt(0).toUpperCase() + string.substr(1)
}

export async function getCodePostalVille (search, pays) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      let url = '/v2/ville-code-postal?nbMax=40&codePostal=' + search
      if (pays != null) {
        url = url + '&pays=' + pays
      }
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          result: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * @param {string} codePostal
 * @param {string|null} pays libellé ou code pays (sera converti en ISO3 pour l'URL)
 * @param {Array<object>|null|undefined} countries optionnel — getCountries du store
 * @returns {Promise<{ items: Array<{ id: number, libelle: string }>, count: number }>}
 */
export async function getQuartiersByCodePostal (codePostal, pays, countries) {
  const cp = codePostal != null ? String(codePostal).trim() : ''
  if (!cp) {
    return { items: [], count: 0 }
  }
  let url = '/v2/quartier?codePostal=' + encodeURIComponent(cp)
  const paysIso3 = paysIso3ForQuartierUrl(pays, countries)
  if (paysIso3 != null && paysIso3 !== '') {
    url += '&pays=' + encodeURIComponent(paysIso3)
  }
  const response = await HTTP_HYPER_ESPACE_BACKEND.get(url)
  const data = response.data
  if (data && Array.isArray(data.items)) {
    return {
      items: data.items,
      count: data.count != null ? data.count : data.items.length
    }
  }
  if (Array.isArray(data)) {
    return { items: data, count: data.length }
  }
  return { items: [], count: 0 }
}

export async function downloadExportFile (filename, filenameToReturn) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      if (filenameToReturn == null) {
        filenameToReturn = filename
      }
      const urlApi = processEnvConfig.VUE_APP_UBIFLOW_API_URL + '/download_export?file=' + filename
      const instance = axios.create()

      const results = instance({
        url: urlApi,
        method: 'GET',
        responseType: 'blob',
        headers: authHeader()
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameToReturn)
        document.body.appendChild(link)
        link.click()
      }).catch(error => {
        return resolve({ type: 'error', message: error })
      })
    }, Math.random() * 1000 + 250)
  })
}

export function deviseSimple (devise) {
  switch (devise) {
    case 'EUR':
      return '€'
      break
    case 'USD':
      return '$'
      break
    default:
      return '€'
      break
  }
}
